/*! skip_compression */

import { QueryClientProvider } from "@tanstack/react-query";
import UserSwitching from "components/embedded/UserSwitching";
import { createRoot } from "react-dom/client";
import queryClient from "services/queryClient";

document.addEventListener("DOMContentLoaded", () => {
  const container = document.getElementById("embedded-user-switching");

  if (container) {
    createRoot(container).render(
      <QueryClientProvider client={queryClient}>
        <UserSwitching />
      </QueryClientProvider>
    );
  }
});
